import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

import getLastSchoolYear from "@/directory/utils/getLastSchoolYear";

dayjs.extend(isBetween);

export const TODAY = dayjs().endOf("day").format("YYYY-MM-DD");
export const START_OF_90_DAYS = dayjs()
  .subtract(90, "days")
  .format("YYYY-MM-DD");
export const START_OF_60_DAYS = dayjs()
  .subtract(60, "days")
  .format("YYYY-MM-DD");
export const START_OF_45_DAYS = dayjs()
  .subtract(45, "days")
  .format("YYYY-MM-DD");
export const START_OF_30_DAYS = dayjs()
  .subtract(30, "days")
  .format("YYYY-MM-DD");
export const START_OF_7_DAYS = dayjs().subtract(7, "days").format("YYYY-MM-DD");

export const JAN_1 = dayjs().month(0).date(1);
export const JUNE_30 = dayjs().month(5).date(30);
export const JULY_1 = dayjs().month(6).date(1);
export const SEPT_15 = dayjs().month(8).date(15);
export const SEPT_16 = dayjs().month(8).date(16);
export const DEC_31 = dayjs().month(11).date(31);

export const IS_INCLUSIVE_BETW_JULY1_TO_SEPT_15 = dayjs(TODAY).isBetween(
  JULY_1,
  SEPT_15,
  undefined,
  "[]",
);

export const IS_INCLUSIVE_BETW_JAN1_TO_JUN30 = dayjs(TODAY).isBetween(
  JAN_1,
  JUNE_30,
  undefined,
  "[]",
);
export const IS_INCLUSIVE_BETW_SEPT16_TO_DEC31 = dayjs(TODAY).isBetween(
  SEPT_16,
  DEC_31,
  undefined,
  "[]",
);

export const START_OF_CURRENT_JULY = dayjs()
  .month(6)
  .startOf("month")
  .format("YYYY-MM-DD");
export const START_OF_LAST_JULY = dayjs()
  .month(6)
  .startOf("month")
  .subtract(1, "year")
  .format("YYYY-MM-DD");

const { startDate, endDate } = getLastSchoolYear();
export const LAST_YEAR_START_DATE = dayjs(startDate).format("YYYY-MM-DD");
export const LAST_YEAR_END_DATE = dayjs(endDate).format("YYYY-MM-DD");
